import React from 'react';
import { useNavigate } from 'react-router-dom';
import SubscriptionForm from './SubscriptionForm';
import './Students.css';
import './GroupForm.css';

const CreateSubscription: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="group-form-container">
      <div className="page-header">
        <div className="page-header-content">
          <h1>New Subscription</h1>
          <p>Create a subscription for a student</p>
        </div>
      </div>

      <div style={{ margin: '0 2rem' }}>
        <SubscriptionForm
          onSuccess={() => navigate('/subscriptions')}
          onCancel={() => navigate('/subscriptions')}
        />
      </div>
    </div>
  );
};

export default CreateSubscription;
